import Vue3TouchEvents from 'vue3-touch-events';
import { App } from 'vue';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default (app: App) => {
  app.use(Vue3TouchEvents, {
    longTapTimeInterval: 200,
  });
};
